import React, { lazy } from "react";
import MainLayout from "../layouts/MainLayout";
import AuthLayout from "../layouts/AuthLayout";
import Home from "pages/Home";
import Loads from "pages/Loads/Loads";
import Request from "pages/Request";
import Login from "pages/Auth/Login";
import Signup from "pages/Auth/Signup";
import ForgetPassword from "pages/Auth/ForgetPassword";
import PrivateRoute from "./PrivateRoute";
import YourRequest from "pages/YourRequest";
import Credit from "pages/Credits";
import Setting from "pages/Settings/";
import OTPVerification from "pages/Auth/OTPVerification";
import CreateAccount from "pages/Auth/CreateAccount";
import SetNewPassword from "pages/Auth/SetNewPassword";
import SharePage from "pages/Share/SharePage";
import AdminDashboard from "../pages/Admin/adminDashboard/adminDashboard";
import UserManagement from "../pages/Admin/userManagement/userManagement";
import CreditsManagement from "../pages/Admin/creditsManagement/CreditsManagement";
import DiscountManagement from "../pages/Admin/discountManagement/discountManagement";
import ReportFeedback from "../pages/Admin/reportFeedback/Reportfeedback";
import Settings from "../pages/Admin/AdminSettings/adminSettings";
import LoadPosted from "../pages/Admin/adminDashboard/loadPosted";
import LoadAnswered from "../pages/Admin/adminDashboard/loadAnswered";
import ContactUs from "pages/Settings/ContactUs";
import NonRevConfiguration from "../pages/Admin/NonRevConfiguration/NonRevConfiguration";
import FavouritesComponent from "pages/Settings/Favourites";

const NotFoundLazy = lazy(() => import("../pages/not-found"));

interface RouteConfigProps {
  path: string;
  element?: React.ReactNode;
  component?: React.ComponentType;
  children?: RouteConfigProps[];
}

const createAuthRoute = (
  path: string,
  Component: React.ComponentType
): RouteConfigProps => ({
  path,
  component: () => (
    <AuthLayout>
      <Component />
    </AuthLayout>
  ),
});

const createPrivateRoute = (
  path: string,
  Component: React.ComponentType
): RouteConfigProps => ({
  path,
  component: () => (
    <PrivateRoute>
      <MainLayout>
        <Component />
      </MainLayout>
    </PrivateRoute>
  ),
});

const createAdminRoute = (
  path: string,
  Component: React.ComponentType
): RouteConfigProps => ({
  path,
  component: () => (
    <PrivateRoute adminOnly={true}>
      <MainLayout>
        <Component />
      </MainLayout>
    </PrivateRoute>
  ),
});

const adminRoutes: RouteConfigProps[] = [
  createAdminRoute("/admin/dashboard", AdminDashboard),
  createAdminRoute("/admin/load-posted", LoadPosted),
  createAdminRoute("/admin/load-answered", LoadAnswered),
  createAdminRoute("/admin/user-management", UserManagement),
  createAdminRoute("/admin/credit-management", CreditsManagement),
  createAdminRoute("/admin/discount-management", DiscountManagement),
  createAdminRoute("/admin/report&feedback", ReportFeedback),
  createAdminRoute("/admin/non-rev-config", NonRevConfiguration),
  createAdminRoute("/admin/settings", Settings),
];

const authRoutes: RouteConfigProps[] = [
  createAuthRoute("/login", Login),
  createAuthRoute("/forgetPassword", ForgetPassword),
  createAuthRoute("/signup/:referralCode?", Signup),
  createAuthRoute("/otpVerification", OTPVerification),
  createAuthRoute("/createAccount", CreateAccount),
  createAuthRoute("/setNewPassword", SetNewPassword),
];

const privateRoutes: RouteConfigProps[] = [
  createPrivateRoute("/", Loads),
  createPrivateRoute("/search", Loads),
  createPrivateRoute("/my-requests", Request),
  createPrivateRoute("/my-loads", YourRequest),
  createPrivateRoute("/credits", Credit),
  createPrivateRoute("/settings", Setting),
  createPrivateRoute("/contact-us", ContactUs),
  createPrivateRoute("/favourites", FavouritesComponent),
];

const publicRoutes: RouteConfigProps[] = [
  {
    path: "/share-request",
    element: <SharePage />,
  },
];

const RoutesConfig: RouteConfigProps[] = [
  ...privateRoutes,
  ...adminRoutes,
  ...authRoutes,
  ...publicRoutes,
  {
    path: "*",
    element: <NotFoundLazy />,
  },
];

export default RoutesConfig;
